module.exports = __webpack_public_path__ + "static/img/share_Module_Header_mytiketi.c717eae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share_Module_Header_mytiketi.jpg
// module id = 958
// module chunks = 32